import { render, staticRenderFns } from "./ForumChatThreadList.vue?vue&type=template&id=55b4e222&scoped=true"
import script from "./ForumChatThreadList.vue?vue&type=script&lang=js"
export * from "./ForumChatThreadList.vue?vue&type=script&lang=js"
import style0 from "./ForumChatThreadList.vue?vue&type=style&index=0&id=55b4e222&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/cli-service/node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "55b4e222",
  null
  
)

export default component.exports